<template>
  <side-panel-inner headerTitle="Responses" class="p-form-create">

    <ul>
        <li v-for='response in responses' :key='response.id'>
            <base-question-response :response='response' />
        </li>
    </ul>
  </side-panel-inner>
</template>

<script>
import BaseQuestionResponse from "@/components/BaseQuestionResponse"
import { mapState } from "vuex";

export default {
  name: "question-responses",

  data() {
    return {
      showValidationMessage: false,
      loading: false
    };
  },

  methods: {
    onUserAdd(val) {
      this.question.user_ids = val.map(val => val.id);
    },

    onInvite() {
      const vm = this;
      this.$store
        .dispatch("Questions/invite", {
          questionId: this.$route.params.questionId,
          userIds: this.userIds
        })
        .then(resp => {
          vm.$store.dispatch(
            "notifications/create",
            {
              body: `Your invite was sent successfully`,
              type: "success"
            },
            { root: true }
          );
          this.$store.dispatch("CLOSE_PANEL");
        })
        .catch(err => {
          vm.$store.dispatch(
            "notifications/create",
            {
              body: `There was a problem sending your invite - ${err}`,
              type: "error"
            },
            { root: true }
          );
        });
    }
  },

  computed: {
    ...mapState("Questions", ["responses"]),

    ...mapState({
      users: state => state.users.collection
    }),
    userIds: {
      get() {
        const ids = this.question.users.map(val => val.id);
        this.question.user_ids = ids;
        return ids;
      },
      set(val) {
        this.question.user_ids = val;
      }
    }
  },

  components: {
    BaseQuestionResponse
  },


  beforeCreate() {
    // this.$store.dispatch("forms/retrieveCategories");
    this.$store.dispatch("users/list");
    this.$store.dispatch("Questions/read", this.$route.params.questionId);
  },

};
</script>


<style lang="scss" scoped>
ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
}
</style>
